// SUNDAY BATCH · D-10 — the figures are STORED (backend/dashboard_store.py) and refreshed by the worker after every change,
// nightly and on Refresh now. A stale block shows its last value with "Updating… (figures as of DD-MMM-YYYY HH:mm)"; a block
// never calculated shows "Updating…" — never a 0, never a blank. `stored` = { state: "ok" | "stale" | "missing", computed_at }.
import React from "react";
import { fmtDateTimeFirm } from "@/lib/dt";
import { fill } from "./fdTheme";

export function isUpdating(stored) {
  return !!stored && (stored.state === "stale" || stored.state === "missing");
}

export function isMissing(stored) {
  return !!stored && stored.state === "missing";
}

export default function UpdatingNote({ stored, t, testid, className = "" }) {
  if (!isUpdating(stored)) return null;
  const text = stored.state === "missing" || !stored.computed_at
    ? t("sbC.updatingNew")
    : fill(t("sbC.updatingAsOf"), { time: fmtDateTimeFirm(stored.computed_at) });
  return (
    <span data-testid={testid} aria-busy="true" className={`block text-xs text-amber-700 dark:text-amber-300 ${className}`}>{text}</span>
  );
}
